import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TERMS_CONDITIONS_DATA } from './terms-conditions.constant';
import { ImageEnum } from '../../utils/image.enum';

@Component({
  selector: 'app-terms-conditions',
  imports: [CommonModule, RouterModule],
  templateUrl: './terms-conditions.html',
  styleUrl: './terms-conditions.css',
})
export class TermsConditionsComponent {
  protected readonly imageEnum = ImageEnum
  protected readonly termsConditionsData = TERMS_CONDITIONS_DATA;
  protected readonly logoImage = 'assets/images/web-landing-page/logo.svg';
  protected readonly termsHeroImage = 'assets/images/web-landing-page/undraw_secure-usb-drive_7pj5 1.svg';
}
